import { toKstDateString } from '@aegislab/shared';

/**
 * Check whether the given ISO date string falls within the last 7 days (KST).
 *
 * X3 단계 6 (D2 정정): correction 도메인 외에 InlineCalendarPicker UI 강조에도
 * 사용되므로 entities/attendance/lib 로 lift. attendance correction window 도메인 로직.
 */
export function isWithin7Days(isoString: string): boolean {
  const dateKst = toKstDateString(new Date(isoString));
  const nowKst = toKstDateString(new Date());
  const diffMs = new Date(nowKst).getTime() - new Date(dateKst).getTime();
  return diffMs <= 7 * 24 * 60 * 60 * 1000;
}
